import { useEffect, useState } from "react";
import Button from "../../Shared/Button";
import { StyledTable, StyledTableCell, StyledTableContainer, StyledTableHead, StyledTableHeaderCell, StyledTableRow } from "./UserTable.styles";
import { Form } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { addToast } from "../../Shared/Toasts/redux/actions";

const AdminUserTable = ({ users, setUserLevel }) => {

  const [tableUsers, setTableUsers] = useState([]);
  const [searchValue, setSearchValue] = useState('');

  const dispatch = useDispatch();

  const handleUserLevel = (userId, level, originalLevel) => {
    const updatedUsers = [...tableUsers];
    const user = updatedUsers.find(user => user.userId === userId);
    user.level = level;
    setTableUsers(updatedUsers);
    setUserLevel(userId, level, originalLevel).then((res) => {
      dispatch(addToast({ header: "Success", body: `${user.name} successfully updated`, time: Date.now(), status: 'success', id: crypto.randomUUID() }))
    }).catch((err) => {
      dispatch(addToast({ header: "Failure", body: `${user.name} failed to  update`, time: Date.now(), status: 'failure', id: crypto.randomUUID() }))
    });
  }

  const userSearch = (input) => {
    setSearchValue(input.toLowerCase())

    const filteredUsers = users.filter((user) => {
      return (
        user?.name?.toLowerCase().includes(input) || user?.userId?.includes(input) || user?.email?.includes(input) || user?.business?.includes(input)
      )
    })
    setTableUsers(filteredUsers);
    if (input.length === 0) {
      setTableUsers(users);
    }
  }

  useEffect(() => {
    setTableUsers(users);
  }, [users])
  return (
    <StyledTableContainer>
      <Form.Group className="mb-3">
        <Form.Label>Search for user</Form.Label>
        <Form.Control type="text" placeholder="Search for name, userId, email or business." value={searchValue} onChange={e => userSearch(e.target.value)} />
      </Form.Group>
      <StyledTable>
        <StyledTableHead>
          <StyledTableRow>
            <StyledTableHeaderCell>Name</StyledTableHeaderCell>
            <StyledTableHeaderCell>Email</StyledTableHeaderCell>
            <StyledTableHeaderCell>Business</StyledTableHeaderCell>
            <StyledTableHeaderCell></StyledTableHeaderCell>
            <StyledTableHeaderCell></StyledTableHeaderCell>
            <StyledTableHeaderCell></StyledTableHeaderCell>
          </StyledTableRow>
        </StyledTableHead>
        <tbody>
          {tableUsers && tableUsers.map((user, index) => (
            <StyledTableRow key={index}>
              <StyledTableCell>{user.username}</StyledTableCell>
              <StyledTableCell>{user.email}</StyledTableCell>
              <StyledTableCell>{user.business}</StyledTableCell>
              <StyledTableCell><Button text={'AIE / Administrator'} buttonStyle={`pink ${user.level >= 1000 ? '' : 'inactive'}`} onClick={() => handleUserLevel(user.userId, 1000, user.level)} /></StyledTableCell>
              <StyledTableCell><Button text={'Authorized'} buttonStyle={`blue ${user.level >= 100 && user.level < 1000 ? '' : 'inactive'}`} onClick={() => handleUserLevel(user.userId, 100, user.level)} /></StyledTableCell>
              <StyledTableCell><Button text={'Guest'} buttonStyle={`green ${user.level < 100 && user.level > 0 ? '' : 'inactive'}`} onClick={() => handleUserLevel(user.userId, 1, user.level)} /></StyledTableCell>
            </StyledTableRow>
          ))}
        </tbody>
      </StyledTable>
    </StyledTableContainer>
  )
}

export default AdminUserTable;